import { render, staticRenderFns } from "./DesktopPlug.vue?vue&type=template&id=639cf363&scoped=true&"
import script from "./DesktopPlug.vue?vue&type=script&lang=js&"
export * from "./DesktopPlug.vue?vue&type=script&lang=js&"
import style0 from "./DesktopPlug.vue?vue&type=style&index=0&id=639cf363&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639cf363",
  null
  
)

export default component.exports